import {useState, useCallback, useRef } from 'react';
import Draggable from 'react-draggable';
import styled from 'styled-components';
import DragHandlerIcon from '@vds/icons/drag-handler';
import CloseAlternate from '@vds/icons/close-alternate';
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Button } from '@vds/buttons';
import { apiUrl } from './../../constants/apiUrl';
import axios from 'axios';
import { Input } from '@vds/inputs';
import { Notification } from '@vds/notifications';
import Keyboard from '../fiosRetailTablet/Keyboard/Keyboard';
import '../fiosRetailTablet/Keyboard/Keyboard.css'
import CloseIcon from '@vds/icons/close';
import { openModalWindow } from '../../action/modalWindow';


let tokenUpdatedTime = 0;
let tokenDuration = 0;
let tokenValidUpto = 0;
let access_token = '';

const KeyboardHeader = styled.div`
    background: rgba(131, 131, 131, 0.4);
    border: 0.5px solid #DDD;
    border-radius-top-left: 3px;
    display: block;
    padding: 3px 5px;
    text-align: center;
    color: white;
    width: 67.7rem !important;
    display: flex;  
`;

const Animated = styled.span`
animation-name: slide-up;
animation-duration: 0.85s;
animation-timing-function: ease-in-out;
display:block;
 @keyframes slide-up {
    0% {
        transform: translateY(60%);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}`;

export const MNHSIGNINOVERLAY = (props)=>{
    const {dispatch} = props;
    const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
    const hostedAttractLoop = sessionStorage.getItem("hostedAttractLoop") === "true";
    const [mtn, setMTNInput] = useState('');
    const [zip, setZipInput] = useState('');
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorNotification, setErrorNotification] = useState(false);
    const [errorZip, setErrorZip] = useState(false);
    const [isKeyboardForMNH, setKeyboardForMNH] = useState(false);
    const [inputName, setKeyboardName] = useState("");
    const [keyboardContainerClass, setKeyboardContainerClass] = useState("keyboard-container-for-mnh-phone .floating-keyboard-container")
    const keyboard = useRef(null);
    const keyPressed = useRef("");
    const [showModal,setShowModal] = useState(true)

    const closeKeyboardMNH = useCallback(() => {
      setKeyboardForMNH(false);
    });    


    const isKeyboardClickedForMNH = useCallback((e) => {
      // const input = document.getElementsByTagName('input')[1];
      // let margin = document.getElementsByClassName('main')[0].style.marginTop
      // margin = "-170px"
      // document.getElementsByClassName('main')[0].style =`margin-top: ${margin}; transition: margin-top 0.5s ease`;
     
      if (isFiOSFlag && hostedAttractLoop) {
          const name = e.target.name;
          setKeyboardName(name);
          setKeyboardForMNH(true);
          if (name === 'mobileNumber') {
            setKeyboardContainerClass("keyboard-container-for-mnh-phone setKeyboardContainerClass");
          } else if (name === "zipCode") {
            setKeyboardContainerClass("keyboard-container-for-mnh-zipcode setKeyboardContainerClass");
          }

          // if(name === 'mobile' && mobileRef && mobileRef.current) {
              
          //     mobileRef.current.scrollIntoView({
          //         behavior: 'smooth', // Optional: Adds smooth scrolling animation
          //         block: 'start' // Optional: Scrolls to the top of the element
          //       });
          // } else if (this.phone && this.phone.current) {
          //     setTimeout(() => this.setState({ name, isKeyboardForMOB: true  }), 300);

          //     phone.current.scrollIntoView({
          //         behavior: 'smooth', // Optional: Adds smooth scrolling animation
          //         block: 'center' // Optional: Scrolls to the top of the element
          //       });
          // }
      }        
    });

    const keyboardOnKeyPressMNH = useCallback((button) => {
      console.log('keyPressed')
      keyPressed.current = button;

    });

    const keyboardOnChangeMNH = useCallback((value) => {
      if(inputName === 'mobileNumber') {
        onMobileChangeHandler(value)

      } else if (inputName === 'zipCode') {
        onZipCodeChange(value);
      }
    })
  

    const doValidate = (e)=>{
      if(mtn === ''){
        setErrorMobile(true);
      }
      else if(zip === ''){
        setErrorZip(true);
      }
      else{
        if(!(errorMobile || errorZip)){
          props.validateSignin(mtn,zip,false);
        }
      }
    }

    const onZipCodeChange = (val)=>{
      if(keyboard && keyboard.current && keyboard.current.setInput && keyPressed && keyPressed.current === "Clear") {
        setZipInput("")
        keyboard.current.setInput("");
        return;
      }
      const pattern = /^\d{4,5}$/;
      if (pattern.test(val)){
        setErrorZip(false);
      }
      else{
        setErrorZip(true);
      }
      setZipInput(val);
      if (keyboard && keyboard.current && keyboard.current.setInput) {
          keyboard.current.setInput(val);
      }
    }

    const onMobileChangeHandler = (val)=>{
      if(keyboard && keyboard.current && keyboard.current.setInput && keyPressed && keyPressed.current === "Clear") {
        setMTNInput("")
        keyboard.current.setInput("");
        return;
      }
      if (String(val).length > 10) {
        return null;
      } 

      const pattern = /^[0-9a-zA-Z]+$/;
      if (pattern.test(val)){
        setErrorMobile(false);
      }
      else{
        setErrorMobile(true);
      }
      setMTNInput(val);
      if (keyboard && keyboard.current && keyboard.current.setInput) {
        keyboard.current.setInput(val);
      }      
    }

    const handleKeyDown = (e) => {
      if (e.keyCode === 13 || e.keyCode === 32) {
        if(mtn==="" || zip==="" || errorZip || errorMobile){
          setErrorNotification(true)
          setTimeout(()=>{
            setErrorNotification(false)
          },4000)
        }     
          doValidate(e);
          e.preventDefault();
      }
    }

    const customHandler = ( ) => {
      setTimeout(()=>{
        let elem = document.querySelector('#mnhMobileNumber div[role="alert"]');
        if(elem){
          elem.setAttribute('role', 'none');
          elem.setAttribute('aria-hidden', 'true');
        }
        let elem2 = document.querySelector('#mnhZipCode- div[role="alert"]');
        if(elem2){
          elem2.setAttribute('role', 'none');
          elem2.setAttribute('aria-hidden', 'true');
        }
      },0)
    }
    const onCloseClick=()=>{
      setShowModal(false);  
      document?.body?.setAttribute("focusMnhSignInCTA", "true");   

      if(props?.modalwindowisocid){
        openModalWindow(`${'MNHMODELOVERLAY_'}${props?.modalwindowisocid}`, dispatch);
      }
      else{
        openModalWindow('mnhFromRibbonBanner', dispatch);
      }
    }

    const handleEsc = (e) => {
      console.log("keypress", e.key);
      if (e.key === 'Escape' || e.key === 'Esc') { 
        e.stopPropagation();
        e.preventDefault();
        onCloseClick();
      }
    }

    return(
      <div>
        <div id="mnsign-on" className="mnhSignIn ResknModalHeader">
          <Modal
            disableOutsideClick={true}
            opened={showModal}
            onOpenedChange={(modalOpened) => setShowModal(modalOpened)}
            closeButton={(<button aria-label="Close" className='mnhpopupSignIN' onClick={onCloseClick} onKeyDown={handleEsc}><CloseIcon size="23" tabIndex="0" /></button>)}
            closeButtonId='mnSignIn-modal-close'
            id='mnSignIn-modal'
          >
            <ModalTitle>
              Already have Verizon Wireless? <br aria-hidden="true" /> Sign in to save
            </ModalTitle>
            <ModalBody>
              {errorNotification ? <Notification
                type="error"
                title="Please complete all fields."
                fullBleed={false}
                inline={false}
                disableFocus={true}
                hideCloseButton={true}
              /> : null}
              <p className="title-body-desc"> Verizon wireless customers can get a Mobile + Home Discount with an eligible internet plan.</p>
              <Input name="mobileNumber" type="tel" label='Verizon Mobile number *' id='mnhMobileNumber' value={mtn} onChange={e => !hostedAttractLoop && onMobileChangeHandler(e.target.value)} error={errorMobile}
                onClick={(e) => isKeyboardClickedForMNH(e)}
                // errorText={errorMobile ? "You must enter a Verizon Mobile number" : ""}
                aria-label="" onBlur={(e) => {
                  if (e.target.value === "") {
                    customHandler()
                    setErrorMobile(true);
                  }
                }} required={true} />
              {errorMobile ? <span role="alert" aria-live='assertive' className='custom-error-mnh'>You must enter a Verizon Mobile number</span> : null}
              <Input name="zipCode" type="text" label='Zip Code *' id='mnhZipCode-' value={zip} onChange={e => !hostedAttractLoop && onZipCodeChange(e.target.value)} maxLength={5} error={errorZip} aria-label=""
                onClick={(e) => isKeyboardClickedForMNH(e)}
                onBlur={(e) => {
                  if (e.target.value === "") {
                    customHandler();
                    setErrorZip(true);
                  }
                }}
                required={true}
              />
              {errorZip ? <span role={!zip ? "alert" : "none"} aria-live='assertive' className='custom-error-mnh'>Enter a Valid ZIP code</span> : null}
              {hostedAttractLoop && <div className={keyboardContainerClass}>
                {isKeyboardForMNH && isFiOSFlag &&
                  <Draggable handle="strong" >
                    <Animated>
                      <KeyboardHeader className="keyboard-header" >
                        <strong className="cursor"><DragHandlerIcon color="white" /></strong><div onClick={closeKeyboardMNH} className="close"><CloseAlternate color="white" /></div>
                      </KeyboardHeader>
                      <Keyboard
                        ref={keyboard}
                        onChange={(e) => keyboardOnChangeMNH(e)}
                        onKeyPress={(button) => keyboardOnKeyPressMNH(button)}
                        theme={"numericLocker"}
                        inputName={inputName}
                        key={inputName}
                      />
                    </Animated>
                  </Draggable>
                }
            </div>
            }
            </ModalBody>
            <ModalFooter>
              <div className="btnGroup">
                <Button
                  disabled={zip === "" || mtn === "" || errorZip || errorMobile}
                  aria-disabled={zip === "" || mtn === "" || errorZip || errorMobile ? 'true' : false}
                  size="large"
                  id="mnhValidateButton"
                  onClick={doValidate}
                  onKeyDown={(e) => handleKeyDown(e)}
                >
                  Validate
                </Button>
              </div>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
}

export const checkTokenValidity = ()=>{
    if (Date.now() >= getFromStorage('tokenValidUpto')){
        return false;
    }
    return true;
}

export const getFromStorage = (key) => {
    const cookieValue = getCookie(key);
    return cookieValue !== '' ? cookieValue : window.sessionStorage.getItem(key);
};

export function getCookie(cname) {
    try {
      const cookies = document.cookie;
      const name = `${cname}=`;
      const decodedCookie = decodeURIComponent(cookies);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    } catch (e) {
      return null;
    }
}

export const genarateToken = () =>
  new Promise((resolve) => {
    const url = apiUrl().tokenGeneration;
    axios({
        url: url,
        method: 'GET',
        responseType: 'json',
        cache : false,
        headers: {
            "Content-Type": "application/json"
           },
        timeout: 90000
      })
      .then((response) => {
        if (response && response.data) {
          processTokenResponse(response, resolve);
        }
      })
      .catch((error) => {
        resolve(error);
      });
  });

export const setToStorage = (key, value) => {
    window.sessionStorage.setItem(key, value);
};

export const processTokenResponse = (response, resolve) => {
    tokenDuration = parseInt(response.data.expires_in) * 1000 || 0; // conv s to mS
    const access_token_issuedAt = parseInt(response.data.issued_at);
    tokenUpdatedTime = access_token_issuedAt || tokenUpdatedTime; // epoch time in ms
    tokenValidUpto = tokenUpdatedTime + tokenDuration - 100000; // to renew new token 100s before it expires
    access_token = response.data;
    setToStorage('tokenValidUpto', tokenValidUpto);
    setToStorage('token', access_token);
    resolve(response);
    const geoHdr = response.headers ? response.headers['x-ec-geohdr'] : '';
    geoHdr &&
      geoHdr !== '' &&
      (function () {
        const stateIdx = geoHdr.indexOf('region_code=');
        // let ghdr = "country_code=US,region_code=,city=,dma=-1,msa=-1,lat=37.7510,long=-97.8220,zip=,continent=NA,timezone=";
        const getcountrycode = geoHdr
          .slice(0)
          .split(',')
          .reduce((final, current) => {
            const getcountrycodevalue = current.split('=');
            return typeof getcountrycodevalue === 'string' && getcountrycodevalue.length === 2
              ? { ...final, [getcountrycodevalue[0]]: getcountrycodevalue[[1]] }
              : { ...final };
          }, {});
        const countrycode = getcountrycode.country_code;
        setToStorage('countrycode', countrycode);
        if (stateIdx > 0) {
          const stateString = geoHdr.slice(stateIdx + 12);
          const userState = stateString.slice(0, 2);
          setToStorage('prefSt', userState);
        }
      })(geoHdr);
  }
